import PropTypes from "prop-types";

import "./no-results.scss";

const NoResults = ({ tabText, mainText, subText }) => {
  const defaultMessage = `No Search Results in ${tabText}`;
  const defaultSubMessage =
    "Please select another asset style category above for more search results.";
  const message = mainText ? mainText : defaultMessage;
  const subMessage = subText ? subText : defaultSubMessage;
  return (
    <div className="no-results">
      <div className="no-results__content">
        <p className="no-results__primary-text">{message}</p>
        <p className="no-results__sub-text">{subMessage}</p>
      </div>
    </div>
  );
};

NoResults.propTypes = {
  tabText: PropTypes.string,
  mainText: PropTypes.string,
  subText: PropTypes.string,
};

export default NoResults;
